import { observer } from 'mobx-react';
import * as React from 'react';

import ProductSearchStore from 'search/stores/product-search-store';
import { CustomRefinementListComponent } from './custom-parent-refinement-component';

interface ShowerValvesTypeFilterProps {
  store: ProductSearchStore;
}

const ShowerValvesTypeFilter = observer(
  class ShowerValvesTypeFilter extends React.Component<ShowerValvesTypeFilterProps> {
    private containerRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
      const { store } = this.props;
      const { showerValvesTypeFilterOpened: opened } = store;
      if (!opened && this.containerRef.current) {
        this.containerRef.current.style.display = 'none';
      }
    }

    render() {
      const { store } = this.props;
      const { showerValvesTypeFilterOpened: opened } = store;
      const classes = ['c-filters__group', opened ? 'is-open' : ''];
      return (
        <>
          <div className={classes.join(' ')}>
            <div
              className="c-filters__header c-accordion-toggle"
              onClick={() => {
                store.setShowerValvesTypeFilterOpened(!opened);
                if (this.containerRef.current) {
                  jQuery(this.containerRef.current).stop(true).slideToggle();
                }
              }}
            >
              <p className="c-filters__title">Shower Valves</p>
            </div>
            <div className="c-filters__container c-accordion-container" ref={this.containerRef}>
              <CustomRefinementListComponent
                attribute="shower_valves_type"
                limit={25}
                subrefinements={[{ attribute: 'pressure_balancing_type', key: 'Pressure Balancing (Temptrol)' }]}
              />
            </div>
          </div>
        </>
      );
    }
  }
);
export default ShowerValvesTypeFilter;
